
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Smartphone } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MobileBadgeProps {
  className?: string;
  variant?: 'default' | 'collapsed';
}

export const MobileBadge: React.FC<MobileBadgeProps> = ({ 
  className,
  variant = 'default'
}) => {
  if (variant === 'collapsed') {
    return (
      <div className={cn(
        "w-2 h-2 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full flex-shrink-0",
        className
      )} />
    );
  }

  return (
    <Badge 
      className={cn(
        "ml-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-xs font-bold px-2 py-0.5 border-0 hover:from-cyan-600 hover:to-blue-600 transition-all duration-200 flex items-center gap-1",
        "group-data-[collapsible=icon]:hidden",
        className
      )}
    >
      <Smartphone className="h-3 w-3" />
      <span>Optimized</span>
    </Badge>
  );
};
